function updateEdgeRelated(node, dispatch){
    if(node.edgesFrom.length){
        node.edgesFrom.forEach(edge => {
            const updatedData = {
                edgeId: edge,
                startPosX: node.x,
                startPosY: node.y,
            }
            dispatch('edges/updateEdge', updatedData, {root: true});
        })
    }
    if(node.edgesTo.length){
        node.edgesTo.forEach(edge => {
            const updatedData = {
                edgeId: edge,
                endPosX: node.x,
                endPosY: node.y,
            }
            dispatch('edges/updateEdge', updatedData, {root: true});
        })
    }
}

function preparePositionDataRequest({nodeIDs, nodes}){
    const data = {'nodes': []};
    let nodesIdToSave = [];

    nodeIDs.forEach(nodeIdToSave => {
        nodesIdToSave.push(nodeIdToSave);
        const node = nodes.find(node => node.id === nodeIdToSave);
        const model = {
            'id': nodeIdToSave,
            'geometry': {
                'center': {
                    'x': node.x,
                    'y': node.y
                }
            }
        };
        data.nodes.push(model);
    })

    return {data, nodesIdToSave}
}
function restoreNodePosition({nodeIDs, rawNodes, nodes, dispatch}){
    nodeIDs.forEach(nodeId => {
        const nodeOriginal = rawNodes.find(nodeO => nodeO.id === parseInt(nodeId));
        const node = nodes.find(node => node.id === parseInt(nodeId));
        node.x = nodeOriginal.geometry.center.x;
        node.y = nodeOriginal.geometry.center.y;
        updateEdgeRelated(node, dispatch);
    })
}

export {updateEdgeRelated, preparePositionDataRequest, restoreNodePosition}